export const products = {
  title: 'Products and services',
  organizations: "All organizations",
  new: "New product",
  filter: {
    allTypes: "All types",
    products: "Products",
    services: "Services"
  },
  fields: {
    product: "Product",
    organizations: "Organizations",
    price: "Price",
    actions: "Actions",
    tax: "% Tax"
  },
  tooltips: {
    duplicate: "Duplicate",
    edit: "Edit",
    delete: "Delete",
  },
  messages: {
    deleteConfirm: 'Are you sure you want to delete this product?',
    noMoreOrgs: 'No more organizations to add',
    confirmTitle: 'Product deletion',
    deleteQuestion: 'Are you sure you want to delete this product?',
    deleteWarning: 'This action cannot be undone.'
  },
  copy: "Copy",
  edit: "Edit",
  delete: "Delete",
  moreActions: "More actions",
  deactivate: "Deactivation",
  form: {
    add: "Create new product",
    edit: "Edit product",
    type: {
      title: "Product type",
      product: "Product",
      service: "Service"
    },
    basicInfo: {
      title: "Product data",
      name: "Name",
      code: "Code",
      description: "Description",
      unit: "Unit",
    },
    pricing: {
      title: "Organization and pricing",
      price: "Price",
      currency: "Currency",
      taxRate: "Tax rate (%)",
    },
    buttons: {
      add: "Add product",
      update: "Update product",
      cancel: "Cancel",
    }
  }
}